import { TEXT_CONST, type TextProps } from './Text.d';
import TextBase from './Text.styles';

const Text = ({
  children,
  color,
  overline = false,
  textAlign = 'left',
  variant = 'body-medium-standard',
  marginBottom = 'sp-0',
  ...props
}: TextProps) => (
  <TextBase
    data-color={color}
    data-overline={overline}
    data-testid={TEXT_CONST.TEST_ID}
    data-text-align={textAlign}
    data-variant={variant}
    data-margin-bottom={marginBottom}
    {...props}
  >
    <span
      data-color={color}
      data-overline={overline}
      data-text-align={textAlign}
      data-variant={variant}
      {...props}
    >
      {children}
    </span>
  </TextBase>
);

export default Text;
